import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import type {
  CreatePlanInput,
  Plan,
  UpdatePlanInput,
} from "@/features/plans/schemas/plan";
import {
  createPlan,
  deletePlan,
  listPlans,
  updatePlan,
} from "@/features/plans/services/plansService";

export const planKeys = {
  all: ["plans"] as const,
  list: () => [...planKeys.all, "list"] as const,
};

/**
 * Planes de suscripción desde Firestore (`plans`).
 */
export function usePlans() {
  return useQuery<Plan[]>({
    queryKey: planKeys.list(),
    queryFn: listPlans,
    staleTime: 5 * 60 * 1000,
  });
}

export function useCreatePlan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreatePlanInput) => createPlan(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: planKeys.all });
    },
  });
}

export function useUpdatePlan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ docId, data }: { docId: string; data: UpdatePlanInput }) =>
      updatePlan(docId, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: planKeys.all });
    },
  });
}

export function useDeletePlan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (docId: string) => deletePlan(docId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: planKeys.all });
    },
  });
}
